import React, { FC } from 'react';
import classNames from 'classnames';

import './NewLandingMore.scss';
import IconCustom from 'components/common/IconCustom';
import UmbracoImage from 'components/common/Image/UmbracoImage';
import { INewLandingMore } from './models';
import PlainImage from 'components/common/Image/PlainImage';
import DangerouslySetInnerHtml from 'components/common/DangerouslySetInnerHtml';

const NewLandingMore: FC<INewLandingMore> = ({
  heading,
  leftFeatures,
  rightFeatures,
  menuLinks,
  image: leftImage,
  productImageDesktop: rightImage,
}) => {
  console.log(leftImage);
  console.log(rightImage);
  return (
    <div className={classNames('new-lp-more product-benefits-spread')}>
      <DangerouslySetInnerHtml html={heading} className="new-lp-more__heading" element="h1" />
      <div className="new-lp-more__row">
        <div className="new-lp-more__content">
          <PlainImage
            src={leftImage.fallbackUrl}
            alt={leftImage.altText}
            className="new-lp-more__image"
          />
          {leftFeatures?.map((feature, idx) => (
            <div key={idx} className="new-lp-more__feature new-lp-more__feature--left">
              <IconCustom icon={feature.properties.iconName} />
              <div>{feature.properties.description}</div>
            </div>
          ))}
          <div className="new-lp-more__link">
            <span className="new-lp-more__link-name">{menuLinks[0]?.name}</span>
            <a
              href={`${menuLinks[0].url}`}
              className="btn lp-button--buy-now"
              target="_blank"
              rel="noreferrer"
            >
              Buy Now
            </a>
          </div>
        </div>
        <div className="new-lp-more__content">
          <PlainImage
            src={rightImage.fallbackUrl}
            alt={rightImage.altText}
            className="new-lp-more__image"
          />
          {rightFeatures?.map((feature, idx) => {
            return (
              <div key={idx} className="new-lp-more__feature">
                <IconCustom icon={feature.properties.iconName} />
                <div>{feature.properties.description}</div>
              </div>
            );
          })}
          <div className="new-lp-more__link">
            <span className="new-lp-more__link-name">{menuLinks[1]?.name}</span>
            <a
              href={`${menuLinks[1].url}`}
              className="btn lp-button--buy-now"
              target="_blank"
              rel="noreferrer"
            >
              Buy Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewLandingMore;
